var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 27,
    viewBox: "0 0 40 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,24.42394V8.99747l17.15598,10.61209c.40582,.25101,.83585,.43749,1.27651,.57237,.03557,.01089,.06975,.02785,.10551,.03801,.12438,.03524,.25147,.05325,.37738,.07938,.11633,.02409,.23141,.05701,.34874,.07331,.09575,.01326,.19242,.01188,.28863,.01999,.149,.01254,.29773,.03095,.44719,.03095h.00033c.07456,0,.14867-.01234,.22317-.01544,.90804-.03801,1.80968-.29694,2.62059-.79857l15.60767-9.65449,1.54831-.95773v15.4266c0,1.19251-.96974,2.16225-2.16225,2.16225H2.16225c-1.19251,0-2.16225-.96974-2.16225-2.16225ZM37.83775,.41381H2.16225C.96974,.41381,0,1.38355,0,2.57606v3.87895l18.29359,11.31538c1.05209,.65089,2.36021,.65195,3.4123,0l14.6149-9.0397,3.67921-2.27574V2.57606c0-1.19251-.96974-2.16225-2.16225-2.16225Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a77f8ac16b9984a18ae23af388e77ee5.svg";
export { ForwardRef as ReactComponent };